import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the view for promotional codes table.
 * @extends JetView
 */
export default class tablePromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Set the height based on screen width
            height: screen.width < 500 ? 400 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip for the edit icon
                    tooltip: 'Editar',
                    // Template function to render the edit icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                // Column for ID with sorting enabled
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                // Column for Code with sorting enabled
                { id: 'Code', header: 'Código', width: 250, sort: 'int' },
                {
                    // Column for creation date with localization
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    // Format the date using the defined date format
                    format: dateFormat,
                },
                // Column for LinkId with sorting enabled
                { id: 'LinkId', header: 'LinkId', width: 250, sort: 'int' },
                {
                    // Column for activation status with options
                    id: 'IsActivate',
                    header: 'Estado',
                    options: [
                        { id: 'A', value: 'Activo' },
                        { id: 'I', value: 'Inactivo' },
                    ],
                    width: 150,
                    sort: 'int',
                },
            ],
            // Define click event for the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit code dialog
                    $$('EditCode').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching configuration
            loadahead: devConfig.getDefaultDataFetch(),
            // Define the pager for pagination
            pager: 'pagerA',
            // Set the URL for fetching data from the API
            url: devConfig.geturlApi() + 'es/PromotionalCodes/GetCodes?FromId=' + cur_user + '&',
            // Sample data for the datatable
            data: [
                {
                    Id: '01',
                    Code: '0101',
                    CreatedLocalDate: '2019-02-03',
                    ModifiedLocalDate: '2019-02-06',
                    LinkId: '0105',
                    IsActivate: 'A',
                },
                {
                    Id: '02',
                    Code: '0103',
                    CreatedLocalDate: '2019-02-10',
                    ModifiedLocalDate: '2019-02-12',
                    LinkId: '0106',
                    IsActivate: 'A',
                },
            ],
            // Define double-click event for items in the datatable
            on: {
                onItemDblClick: (id) => {
                    // Show the edit code dialog on double-click
                    $$('EditCode').show();
                },
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);
        // Store the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Listen for the 'promotionalCodes:filter' event on the application
        this.on(this.app, 'promotionalCodes:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            // Initialize a string to build the query parameters
            var string1 = '';
            // Iterate over each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - ');
                        // Append date range to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Handle the 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - ');
                            // Append modified date range to the query string
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            // Append other filters to the query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate over each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle the 'start' date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the start date and append to the query string
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle the 'end' date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the end date and append to the query string
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the query string
            string1 = string1 + '&FromId=' + cur_user;
            // Clear the existing grid data
            grid.clearAll();
            // Load the grid with the new data based on the constructed URL and filter
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Set the starting point and count for pagination
                    filter + // Apply any existing filters
                    '&sort[' +
                    by + // Specify the field to sort by
                    ']=' +
                    dir, // Specify the direction of sorting (ascending/descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item using its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                grid.data.url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Set the starting point and count for pagination
                    '&PlayerId=' +
                    Id, // Filter the data by the selected player's ID
            );
        });
        // Create a popup window for editing promotional codes
        var popup = webix.ui({
            // Define the type of UI component as a window
            view: 'window',
            // Unique identifier for the window
            id: 'EditCode',
            // Header section of the window
            head: {
                view: 'toolbar',
                cols: [
                    // Label for the window
                    { view: 'label', label: 'Editar Código' },
                    {
                        // Close icon button
                        view: 'icon',
                        icon: 'wxi-close',
                        // Click event to hide the window
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            // Position the window in the center of the screen
            position: 'center',
            // Make the window modal
            modal: true,
            // Body section of the window containing the form
            body: {
                view: 'form',
                // Unique identifier for the form
                id: 'editForm',
                // Elements of the form
                elements: [
                    // Read-only field for ID
                    { view: 'text', label: 'ID', name: 'Id', readonly: true },
                    // Editable field for Code
                    { view: 'text', label: 'Código', name: 'Code' },
                    {
                        // Read-only field for Creation Date
                        view: 'text',
                        label: 'Fecha de Creación',
                        labelWidth: 140,
                        name: 'CreatedLocalDate',
                        readonly: true,
                    },
                    // Editable field for LinkId
                    { view: 'text', label: 'LinkId', name: 'LinkId' },
                    {
                        // Dropdown for selecting the status
                        view: 'combo',
                        label: 'Estado',
                        name: 'IsActivate',
                        options: [
                            // Option for activated status
                            { id: 'A', value: 'Activado' },
                            // Option for deactivated status
                            { id: 'I', value: 'Inactivado' },
                        ],
                    },
                    {
                        // Container for buttons
                        cols: [
                            {
                                // Cancel button
                                view: 'button',
                                value: 'Cancelar',
                                // Click event to hide the window and reset the form
                                click: function () {
                                    this.getTopParentView().hide();
                                   $$('editForm').setValues($$('editForm').getCleanValues());
                                },
                            },
                            {
                                // Save button with form type
                                view: 'button',
                                type: 'form',
                                value: 'Guardar',
                                // Click event to handle form submission
                                click: function ($e) {
                                    // Get values from the form
                                    var values =$$('editForm').getValues();
                                    // Send an AJAX POST request to update the code
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/UpdateCode',
                                            // Construct JSON payload for the request
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}',
                                            {
                                                // Error callback for AJAX request
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! ');
                                                },
                                                // Success callback for AJAX request
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message('Código Actualizado');
                                                    // Clear the grid and reload data
                                                    grid.clearAll();
                                                    grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter);
                                                },
                                            },
                                        );
                                    // Reset the form values after submission
                                   $$('editForm').setValues($$('editForm').getCleanValues());
                                    // Hide the window after submission
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a local date string in the format YYYY:MM:DD
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() + // Get the current year
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)) // Get the current month (0-indexed)
                .slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Get the current date

        // Initialize a popup window for adding a new code
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'AddCode', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: 'Añadir Código' }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close',
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'addform', // Unique identifier for the form
                elements: [
                    { view: 'text', label: 'Código', name: 'Code' }, // Input for the code
                    {
                        view: 'text', // Input for the creation date
                        label: 'Fecha de Creación',
                        labelWidth: 140, // Width of the label
                        name: 'CreatedLocalDate',
                        value: createdLocalDate, // Set the value to the created local date
                        readonly: true, // Make the field read-only
                    },
                    { view: 'text', label: 'LinkId', name: 'LinkId' }, // Input for the LinkId
                    {
                        view: 'combo', // Dropdown for the activation status
                        label: 'Estado',
                        name: 'IsActivate',
                        options: [
                            { id: 'A', value: 'Activado' }, // Option for activated
                            { id: 'I', value: 'Inactivado' }, // Option for deactivated
                        ],
                    },
                    {
                        cols: [
                            // Define a row of buttons
                            {
                                view: 'button', // Cancel button
                                value: 'Cancelar',
                                click: function () {
                                    // Click event to hide the window and clear form
                                    this.getTopParentView().hide();
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: 'Guardar',
                                click: function ($e) {
                                    // Click event to save the form data
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax() // Perform an AJAX request
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint for adding a code
                                                'PromotionalCodes/AddCode',
                                            '{"Code":"' +
                                                values.Code +
                                                '", "CreatedLocalDate":"' +
                                                createdLocalDate +
                                                '", "LinkId":"' +
                                                values.LinkId +
                                                '" ,"IsActivate":"' +
                                                values.IsActivate +
                                                '" ,"User":"' +
                                                cur_user +
                                                '"}', // JSON string with form data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error callback
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success callback
                                                    webix.message(
                                                        'Código Agregado', // Show success message
                                                    );
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values after submission
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for the 'addCode:button' event on the application instance
        // When the event is triggered, the popupAdd component is displayed
        this.on(this.app, 'addCode:button', (filter) => {
            popupAdd.show(); // Show the popup for adding code
        });

        // Bind the editForm element to the datatable element for data manipulation
        $$('editForm').bind($$('datatable')); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
